import React from "react";
import { Dialog, DialogContent, DialogTitle, Box, Typography, IconButton, List, ListItem, ListItemIcon, ListItemText, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import ImageIcon from "@mui/icons-material/Image";
import DownloadIcon from "@mui/icons-material/Download";
import VisibilityIcon from "@mui/icons-material/Visibility";

const AttachmentViewerModal = ({ open, onClose, attachments = [], selectedAttachment = null }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "20px",
          p: 1.5,
        },
      }}
    >
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", pb: 1 }}>
        <Typography variant="h6" sx={{ fontWeight: 700, fontSize: "1.1rem", color: "#1E293B" }}>
          {selectedAttachment ? selectedAttachment.name : "Attached Documents"}
        </Typography>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ pt: 1 }}>
        {selectedAttachment ? (
          <Box
            sx={{
              p: 3,
              textAlign: "center",
              backgroundColor: "#F8FAFC",
              borderRadius: "14px",
              border: "1px dashed #CBD5E1",
            }}
          >
            {selectedAttachment.type === "pdf" ? (
              <PictureAsPdfIcon sx={{ fontSize: 64, color: "#EF4444", mb: 1.5 }} />
            ) : (
              <ImageIcon sx={{ fontSize: 64, color: "#3B82F6", mb: 1.5 }} />
            )}
            <Typography sx={{ fontWeight: 600, color: "#1E293B", fontSize: "1rem" }}>
              {selectedAttachment.name}
            </Typography>
            <Typography sx={{ color: "#64748B", fontSize: "0.85rem", mb: 2 }}>
              {selectedAttachment.size} • Verified & Encrypted
            </Typography>

            <Box sx={{ display: "flex", justifyContent: "center", gap: 1.5 }}>
              <Button
                variant="outlined"
                startIcon={<VisibilityIcon />}
                size="small"
                onClick={() => alert(`Previewing ${selectedAttachment.name}`)}
                sx={{ textTransform: "none", borderRadius: "10px" }}
              >
                Preview File
              </Button>
              <Button
                variant="contained"
                startIcon={<DownloadIcon />}
                size="small"
                onClick={() => alert(`Downloading ${selectedAttachment.name}`)}
                sx={{ textTransform: "none", borderRadius: "10px", backgroundColor: "#0052CC" }}
              >
                Download
              </Button>
            </Box>
          </Box>
        ) : (
          <List disablePadding>
            {attachments.map((att) => (
              <ListItem
                key={att.id}
                sx={{
                  backgroundColor: "#F8FAFC",
                  borderRadius: "12px",
                  mb: 1,
                  border: "1px solid #E2E8F0",
                  py: 1,
                }}
              >
                <ListItemIcon sx={{ minWidth: 42 }}>
                  {att.type === "pdf" ? (
                    <PictureAsPdfIcon sx={{ color: "#EF4444" }} />
                  ) : (
                    <ImageIcon sx={{ color: "#3B82F6" }} />
                  )}
                </ListItemIcon>
                <ListItemText
                  primary={att.name}
                  secondary={att.size}
                  primaryTypographyProps={{ fontWeight: 600, fontSize: "0.9rem" }}
                  secondaryTypographyProps={{ fontSize: "0.8rem" }}
                />
                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => alert(`Opening ${att.name}`)}
                  sx={{ textTransform: "none", borderRadius: "8px", fontSize: "0.8rem" }}
                >
                  View
                </Button>
              </ListItem>
            ))}
          </List>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default AttachmentViewerModal;
